var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.paramsData.id !== "" ? _vm.$t("modify") : _vm.$t("add"),
            visible: _vm.dialogShow
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "currency_name",
                    label: _vm.$t("currencyName")
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("pleaseInputCurrencyName") },
                    model: {
                      value: _vm.paramsData.currency_name,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "currency_name", $$v)
                      },
                      expression: "paramsData.currency_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "currency", label: _vm.$t("currencySymbol") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        disabled: _vm.paramsData.id ? true : false,
                        placeholder: _vm.$t("pleaseSelectType")
                      },
                      model: {
                        value: _vm.paramsData.currency,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "currency", $$v)
                        },
                        expression: "paramsData.currency"
                      }
                    },
                    _vm._l(_vm.currencyList, function(item) {
                      return _c("el-option", {
                        key: item.currency,
                        attrs: { label: item.currency, value: item.currency }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: { click: _vm.dataFormSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }